// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  unavailableDeliverables: {
    pointerEvents: 'none',

    '& h3': {
      color: 'lightgray',
    },
    '& h4': {
      color: 'lightgray',
    },
    '& p': {
      color: 'lightgray',
    },
    '& span': {
      color: 'lightgray',
    },
    '& img': {
      opacity: 0.4,
    },
  },
  noDeliverableMessage: {
    marginBottom: '8px',
    marginTop: '8px',
    fontSize: 'small',
    fontWeight: 400,
    color: 'lightgray',
  },
  checked: {
    '&.Mui-checked': {
      color: '#01A1DD',
    },
  },
  listItem: {
    padding: '0px',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridColumnGap: theme.spacing(1),
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  itemName: {
    fontWeight: 400,
    fontSize: '13px',
  },
  right: {
    fontWeight: 400,
    fontSize: '13px',
    position: 'absolute',
    right: 0,
  },
  formControl: {
    marginRight: theme.spacing(1),
  },
  layerLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  paperClipIcon: {
    width: '15px',
  },
});

export default styles;
